export default "__VITE_ASSET__DJVGyTlm__"